import { render, staticRenderFns } from "./perfisPermissoesComponente.vue?vue&type=template&id=59ac5788&scoped=true&"
import script from "./perfisPermissoesComponente.vue?vue&type=script&lang=js&"
export * from "./perfisPermissoesComponente.vue?vue&type=script&lang=js&"
import style0 from "./perfisPermissoesComponente.vue?vue&type=style&index=0&id=59ac5788&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59ac5788",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VDataTable,VIcon,VSwitch,VTextField})
